/**
 * BalanceDisplay Component
 * Shows user balance with currency formatting
 */

import React from 'react';

import { useCurrencyFormatter } from '../../hooks';

import './balance-display.scss';

export interface BalanceDisplayProps {
    balance: number;
    label?: string;
    size?: 'small' | 'medium' | 'large';
    showConfirmed?: boolean;
}

export const BalanceDisplay: React.FC<BalanceDisplayProps> = ({
    balance,
    label = 'Available balance',
    size = 'large',
    showConfirmed = false,
}) => {
    const { formatCurrency } = useCurrencyFormatter();

    return (
        <div className={`balance-display balance-display--${size}`}>
            {showConfirmed && (
                <div className="balance-display__confirmed">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
                        <polyline points="22 4 12 14.01 9 11.01" />
                    </svg>
                    <span>Confirmed</span>
                </div>
            )}
            <span className="balance-display__label">{label}</span>
            <h1 className="balance-display__amount">{formatCurrency(balance, 2)}</h1>
        </div>
    );
};

export default BalanceDisplay;
